import i18next from 'i18next';

i18next.addResources('en', 'BlendingInformationModal', {
  blendOperator: 'Blend Operator',
  blendedBy: 'Blended By'
});
